module.exports = __webpack_public_path__ + "static/media/Dosis-Light.16cd99c1.ttf";